import type {SlotGameStore} from "@gamzix/slot_core";

import {CONST} from "../../../src/const";

class GameSymbolView extends SlotGame.src.component.ReelsetComponent.src.SymbolView {
    counter: number;

    protected MILLION: number = 1000000;
    protected KILO: number = 1000;

    protected WILD_MULTIPLIER = {
        1: "empty",
        2:    "x2",
        3:    "x3",
        5:    "x5"
    }

    // for Collector and Doubler fly animation
    async playLanding(isForce = false): Promise<any> {
        if(this.store.gameData.bonusGame.isPlaying() && !isForce) return;

        return super.playLanding();
    }
// override the whole method for change lose mask with different assets bug SAST-215
    public override  createLoseLayer(animationName, symbolAnimationConfig) {
        if (symbolAnimationConfig.loseLayer) {

            let texture = GameSymbolView.config[this.id]['LOSE'].textures[0];
                if (this.id == "2" && this.store.gameData.freeSpinsGame.isPlaying()) {
                    texture =`W_${this.WILD_MULTIPLIER[this.store.gameData.freeSpinsGame.extra.wildMultiplier || 1]}`;
                }

            this.removeLoseLayer();
            this.loseLayer = game.builder.create({
                type: 'Sprite',

                texture: texture,
                alpha: symbolAnimationConfig.loseLayer.alpha,
                tint: symbolAnimationConfig.loseLayer.tint
            });

            this.loseLayer.updateViewOptions();
            this.view.addChild(this.loseLayer);
        }
    }


    shortMoney(val) {
        if (val / this.MILLION >= 1) {
            return (val / this.MILLION).toFixed(2) + 'm';
        } else if (val / this.KILO >= 1) {
            return (val / this.KILO).toFixed(2) + 'k';
        }

        return val;
    }

    public setOverlayView(newValue = null) {
        if (this.store.gameData.freeSpinsGame.isPlaying()
            && this.store.gameData.prevMode !== "main"
            && this.store.gameData.freeSpinsGame.extra.wildMultiplier > 0
            && this.id == CONST.SYMBOLS.WILD) {
                const assetName = this.WILD_MULTIPLIER[this.store.gameData.freeSpinsGame.extra.wildMultiplier];
                this.setCoinImage('W', assetName);
            }

        if (!GameSymbolView.bonusGameConfig.coinSymbolIds.includes(this.id)) return;

        // collector logic exit for restore and lazy loading finish
        if (this.id === CONST.SYMBOLS.COLLECTOR && this.counter && !newValue) return;

        const textConfigView = ReelsetComponent.src.SymbolView.symbolTextConfig.view;
        this.removeOverlayView();
        this.overlayView = game.builder.create(textConfigView);

        let value = this.store.gameData.reels[this.reelId][this.rowId]?.value;

        if (this.rowId < 0) {
            const randomValueIndex = Math.floor(Math.random() * (ReelsetComponent.src.SymbolView.bonusGameConfig.fakeValues.length - 1));
            value = ReelsetComponent.src.SymbolView.bonusGameConfig.fakeValues[randomValueIndex];
        }

        if (!value && this.id !== CONST.SYMBOLS.DOUBLER) return;

        if (newValue) {
            if (this.id === CONST.SYMBOLS.COIN) {
                this.overlayView.options.text = this.shortMoney(this.store.toFormatMoney(newValue * this.store.gameData.bet));
            } else {
                this.overlayView.options.text = this.shortMoney(newValue);
            }
        } else {
            if (this.id === CONST.SYMBOLS.COIN) {
                this.overlayView.options.text = this.shortMoney(this.store.toFormatMoney(value * this.store.gameData.bet));
            } else {
                if (this.id === CONST.SYMBOLS.COLLECTOR) {
                    this.setOverlayImage('collector', { x: 0.92, y: 0.92 });
                } else if (this.id === CONST.SYMBOLS.DOUBLER) {
                    this.setOverlayImage('doubler');
                }
            }
        }

        this.overlayView.updateViewOptions();
        this.view.addChild(this.overlayView);

        // jackpot
        if (this.id == CONST.SYMBOLS.COIN && !newValue) {
            if (String(value) === this.store.gameData.bonusGame.JACKPOT.MAJOR.multiplier.toString()) {
                this.setCoinImage('B', this.store.gameData.bonusGame.JACKPOT.MAJOR.name);
                this.setOverlayImage(this.store.gameData.bonusGame.JACKPOT.MAJOR.name);
                return;
            } else if (String(value) === this.store.gameData.bonusGame.JACKPOT.MINOR.multiplier.toString()) {
                this.setCoinImage('B', this.store.gameData.bonusGame.JACKPOT.MINOR.name);
                this.setOverlayImage(this.store.gameData.bonusGame.JACKPOT.MINOR.name);
                return;
            } else if (String(value) === this.store.gameData.bonusGame.JACKPOT.MINI.multiplier.toString()) {
                this.setCoinImage('B', this.store.gameData.bonusGame.JACKPOT.MINI.name);
                this.setOverlayImage(this.store.gameData.bonusGame.JACKPOT.MINI.name);
                return;
            }
        }
    }

    setCoinImage(symName, skinName) {
        //@ts-ignore
        if (this.view.type === 'AnimatedSprite') {
            //@ts-ignore
            this.view.options.textures = [`${symName}_${skinName}`];
            //@ts-ignore
            this.view.playAnimation();
        } else {
            //@ts-ignore
            this.view.setSkin(skinName);
        }
    }

    setOverlayImage(name, scale = { x: 1, y: 1 }) {
        this.removeOverlayView();

        this.overlayView = game.builder.create({type: "Sprite", texture: `coin_${name}`, scale: scale});
        this.overlayView.updateViewOptions();
        this.view.addChild(this.overlayView);
    }

    public removeOverlayView() {
        const destroy = (container) => {
            if (!container) return;

            if (container.parent) {
                container.parent.removeChild(container);
            }

            container.destroy({
                children: true,
                texture: false,
                baseTexture: false
            });
            game.tree.handleChildChanged();
        }

        destroy(this.overlayView);
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }
}

SlotGame.src.component.ReelsetComponent.src.SymbolView = GameSymbolView;